import DropdownSyncTable from './dropdownSyncTable';

export default DropdownSyncTable;
